<template>
  <v-card style="max-width: 400px; min-width: 300px; margin: auto">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card color="#efefef" class="back--text">
          <v-layout row p1-2>
            <v-flex xs9>
              <v-card-title primary-title>
                <div class="member_name">
                  <div>{{ task.name }}</div>
                  <span class="caption">{{ task.uc ? task.uc.id : "" }}</span>
                </div>
              </v-card-title>
            </v-flex>
            <v-flex xs3 pt-3>
              <v-avatar :tile="false" size="46" color="grey lighten-4">
                <v-img class="elevation-6" :src="avatar"></v-img>
              </v-avatar>
            </v-flex>
          </v-layout>
          <v-divider light></v-divider>
          <v-card-text class="pa-1">
            <v-layout align-center justify-end row fill-height pl-3 pr-2>
              <span>{{
                task.saved_at || task.signedcontract_at | formatarDate
              }}</span>
              <v-spacer />
              <v-tooltip bottom v-if="task.type === 'qualifications'">
                <template v-slot:activator="{ on }" pa-2>
                  <v-btn
                    small
                    round
                    dark
                    :color="badgeColor"
                    v-on="on"
                    style="height: 19px; font-size: 10px"
                  >
                    {{
                      task.uc ? task.uc.status : task.status | formatUserStatus
                    }}
                  </v-btn>
                </template>
                <div>{{ task.status | formatUserStatusDesc }}</div>
              </v-tooltip>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on }" pa-2>
                  <v-btn
                    small
                    round
                    dark
                    :color="badgeColor"
                    v-on="on"
                    style="height: 19px; font-size: 10px"
                  >
                    {{
                      task.uc ? task.uc.status : task.status | formatUserStatus
                    }}
                  </v-btn>
                </template>
                <div>{{ task.bot_status }}</div>
              </v-tooltip>
            </v-layout>
            <v-flex sm12 md12>
              <v-layout align-center justify-end row fill-height pr-2>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }" pa-2>
                    <v-btn
                      icon
                      small
                      round
                      dark
                      color="#efefef"
                      style="margin: 0px 2px"
                      @click="doCopy(task.email)"
                      v-on="on"
                    >
                      <v-icon color="black">mail_outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ task.email }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      round
                      dark
                      color="#efefef"
                      style="margin: 0px 2px"
                      :href="`https://api.whatsapp.com/send?phone=${phone}`"
                      v-on="on"
                    >
                      <v-icon color="green darken-3">mdi-whatsapp</v-icon>
                    </v-btn>
                  </template>
                  <span>Enviar whatsapp para {{ task.phone }}</span>
                </v-tooltip>
                <v-spacer />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="#efefef"
                      round
                      fab
                      small
                      dark
                      @click="generateLink(task)"
                    >
                      <v-icon>link</v-icon>
                    </v-btn>
                  </template>
                  <span>Gerar link para a conexão com a concessionária</span>
                </v-tooltip>
                <v-spacer />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      round
                      dark
                      color="#d0d0d0"
                      style="margin: 0px 2px"
                      @click="
                        task.uc
                          ? goToCustomerCareByUC(task.uc.id)
                          : goToCustomerCareByUser(task.email)
                      "
                      v-on="on"
                    >
                      <v-icon color="black">settings_accessibility</v-icon>
                    </v-btn>
                  </template>
                  <span>Ir para tela de atendimento</span>
                </v-tooltip>
              </v-layout>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { eventBus } from "../../../main";
import { clearPhone } from "../../../utils/utils";
export default {
  props: {
    task: {
      type: Object,
      default: () => ({}),
    },
    showStatus: {
      type: Boolean,
      default: () => false,
    },
    type: {
      type: String,
      default: () => false,
    },
  },
  computed: {
    badgeColor() {
      const mappings = {
        Design: "purple",
        "Feature Request": "teal",
        Backend: "blue",
        QA: "green",
        default: "teal",
      };
      return mappings[this.task.type] || mappings.default;
    },
    avatar() {
      if (this.task.gender === "M") {
        return "https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light";
      } else {
        return "https://avataaars.io/";
      }
    },
    phone() {
      return clearPhone(this.task.phone);
    },
  },
  methods: {
    setAction: function (type, object) {
      if (type === "subscriptions") this.editLead(object);
    },
    editLead: function (lead) {
      this.loading = true;
      // console.log('lead1: ', newLead)
      eventBus.$emit("Lead", lead);
      this.loading = false;
      eventBus.$emit("dialog", true); // emit the event to the bus
    },
    doCopy: function (obj) {
      this.$copyText(obj).then(
        function () {
          // this.show_snack('Copiado para a memoria!','success','top')
          alert("Copiado para a memoria!");
        },
        function () {
          // this.show_snack('Erro ao copiar para a memória!','error','top')
          alert("Erro ao copiar para a memória!");
        },
      );
    },
    goToCustomerCareByUC(uc) {
      this.$router.push({ path: "/atendimento/?installation_number=" + uc });
    },
    goToCustomerCareByUser(email) {
      this.$router.push({ path: "/atendimento/?email=" + email });
    },

    generateLink(lead) {
      console.log("email: ", lead?.email, "utility: ", lead?.utility_company);
      if (lead?.email && lead?.utility_company) {
        const link = `https://juntos.eco/portal?lead=${lead.email}&utility=${lead.utility_company}`;
        navigator.clipboard.writeText(link);
        alert("Link gerado e copiado para área de transferência.");
      } else {
        alert("Preencha todos os campos obrigatórios.");
      }
    },
  },
};
</script>
<style scoped>
.member_name {
  font-weight: 400;
}
</style>
